import { render } from "./QRPayment.vue?vue&type=template&id=e7622ace&scoped=true&ts=true"
import script from "./QRPayment.vue?vue&type=script&lang=ts"
export * from "./QRPayment.vue?vue&type=script&lang=ts"

import "./QRPayment.vue?vue&type=style&index=0&id=e7622ace&scoped=true&lang=css"

import exportComponent from "/builds/kligmanbb/qr-medsafe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7622ace"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QImg,QCardSection});
